import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import { GetVisitorCustomFieldConfigsDocument } from 'graphql-query-contracts';

const EMPTY_CUSTOM_FIELD_CONFIGS: never[] = [];

export const useVisitorCustomFieldConfigs = () => {
  const [fetchConfigs, { data, loading, error, called }] = useLazyQuery(
    GetVisitorCustomFieldConfigsDocument,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    }
  );

  const fetch = useCallback(
    (organizationId: string) => {
      if (!organizationId) return;
      fetchConfigs({ variables: { organizationId } });
    },
    [fetchConfigs]
  );

  return {
    data: data?.visitorCustomFieldConfigs ?? EMPTY_CUSTOM_FIELD_CONFIGS,
    loading,
    error,
    called,
    fetch,
  };
};
